import { Plane } from "lucide-react";

const rows = [
  { time: "06:40", dest: "CAD / SOLIDWORKS", gate: "A1", status: "ON TIME" },
  { time: "07:15", dest: "PYTHON", gate: "A2", status: "BOARDING" },
  { time: "08:05", dest: "UI-UX", gate: "B1", status: "ON TIME" },
  { time: "09:30", dest: "VIDEO EDITING", gate: "B3", status: "DEPARTED" },
  { time: "10:10", dest: "PREMIERE PRO", gate: "B4", status: "ON TIME" },
  { time: "11:45", dest: "SOCIAL & CONTENT", gate: "C2", status: "BOARDING" },
  { time: "13:00", dest: "CLINICAL NEEDS", gate: "C5", status: "ON TIME" },
  { time: "14:20", dest: "REGULATORY · ISO", gate: "D1", status: "DELAYED" },
  { time: "15:55", dest: "PITCH & FUNDRAISE", gate: "D3", status: "BOARDING" },
  { time: "17:30", dest: "GO-TO-MARKET", gate: "E2", status: "ON TIME" },
  { time: "19:05", dest: "RAPID PROTOTYPING", gate: "E6", status: "FINAL CALL" },
  { time: "20:40", dest: "MEDTECH STARTUPS", gate: "E8", status: "BOARDING" },
];

const statusColor = {
  "ON TIME": "text-emerald-300",
  BOARDING: "text-[#FF66B2]",
  DEPARTED: "text-white/40",
  DELAYED: "text-amber-300",
  "FINAL CALL": "text-[#FF1493]",
};

const Row = ({ r, i }) => (
  <div
    data-testid={`skill-row-${r.dest.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className="board-row grid grid-cols-[2.6rem_1fr_1.6rem_4.6rem] gap-2 items-center px-5 py-3 font-tech text-[10px] tracking-[0.06em] uppercase transition-colors duration-300 hover:bg-[#FF1493]/10"
    style={{ animationDelay: `${i * 0.06}s` }}
  >
    <span className="text-white/45">{r.time}</span>
    <span className="text-white/90 truncate">{r.dest}</span>
    <span className="text-white/45">{r.gate}</span>
    <span className={`text-right ${statusColor[r.status]}`}>{r.status}</span>
  </div>
);

export const SkillsBoard = () => (
  <div className="tile-glow rounded-3xl border border-white/10 bg-[#070707] overflow-hidden" data-testid="project-tile-skills">
    <div className="flex items-center justify-between px-5 py-3 border-b border-white/10 bg-white/[0.03]">
      <span className="font-tech text-[10px] tracking-[0.35em] uppercase text-[#FF66B2] flex items-center gap-2">
        <Plane size={12} strokeWidth={1.5} /> Departures · Skills
      </span>
      <span className="font-tech text-[10px] tracking-[0.3em] uppercase text-white/40 flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-[#FF1493] rec-dot" /> LIVE
      </span>
    </div>
    <div className="grid grid-cols-[2.6rem_1fr_1.6rem_4.6rem] gap-2 px-5 py-2 border-b border-white/10 font-tech text-[8px] tracking-[0.3em] uppercase text-white/30 md:hidden">
      <span>Time</span><span>Destination</span><span>Gate</span><span className="text-right">Status</span>
    </div>
    <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 border-b border-white/10">
      {[0, 1, 2].map((c) => (
        <div key={c} className={`grid grid-cols-[2.6rem_1fr_1.6rem_4.6rem] gap-2 px-5 py-2 font-tech text-[8px] tracking-[0.3em] uppercase text-white/30 ${c === 2 ? "hidden lg:grid" : ""}`}>
          <span>Time</span><span>Destination</span><span>Gate</span><span className="text-right">Status</span>
        </div>
      ))}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 board-grid">
      {rows.map((r, i) => <Row key={r.dest} r={r} i={i} />)}
    </div>
  </div>
);
